import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'

import CreditApplicationsDataGrid from './CreditApplicationsDataGrid'
import DashboardFooter from './DashboardFooter'
import DashboardHeader from './DashboardHeader'
import styles from './styles.module.scss'

const Dashboard = () => {
  const [getClassName] = useNameFormatter('Dashboard')

  return (
    <div className={styles[getClassName('')]}>
      <DashboardHeader />
      <CreditApplicationsDataGrid />
      <DashboardFooter />
    </div>
  )
}

export default Dashboard
